import React from 'react';
import PropTypes from 'prop-types';
import {
  nativeFunction,
  callNativeFunction,
  nativeFunctionParamsConstant,
  OS,
} from '@/utils/detectDevice';
import { DEVICE } from '@/constants';
import VERSION_NAME, { lessThan } from '@/utils/historyVersion';

class NativeAudioBtn extends React.Component {
  [DEVICE.PC] = {
    play: () => {
      this.audioRef.current.currentTime = 0;
      this.audioRef.current.play();
    },
    stop: () => {
      this.audioRef.current.pause();
    },
  };

  // JSON.stringify(this.props.playData)

  [DEVICE.MOBILE] = {
    play: async () => {
      (this.isSoundEffect() && await lessThan(VERSION_NAME.LIBRARY_SOUND_EFFECT))
        ? callNativeFunction(nativeFunction.NOT_EXIST)()
        : callNativeFunction(nativeFunction.PLAY_LOCAL_AUDIO)({
          url: this.props.src,
          speed: 1,
          type: this.isSoundEffect()
            ? nativeFunctionParamsConstant.SOUNDS
            : nativeFunctionParamsConstant.EXERCISE,
          playData: this.props.playData,
        });
    },
    stop: () => {
      callNativeFunction(nativeFunction.STOP_LOCAL_ALL)();
    },
  };

  [DEVICE.PAD] = this[DEVICE.MOBILE];

  constructor() {
    super();
    this.audioRef = React.createRef();
  }

  componentDidMount() {
    window.onfire.on('endedPlay', () => {
      console.log('endedPlay');
      this.stop();
    });

    window.onfire.on('audioStart', (playData) => {
      console.log('audioStart', playData.playData);
      this.changeBtnStatus(playData);
    });
  }

  componentWillUnmount() {
    window.onfire.off('endedPlay');
    window.onfire.off('audioStart');
  }

  isSoundEffect = () => this.props.src.indexOf('Library/sounds/') > -1;

  play = () => {
    // console.log(
    //   'playNativeAudio',
    //   this.props.src,
    //   1,
    //   this.isSoundEffect()
    //     ? nativeFunctionParamsConstant.SOUNDS
    //     : nativeFunctionParamsConstant.EXERCISE,
    //   this.props.playData,
    // );
    this[OS.TYPE].play();
  };

  stop = () => {
    this[OS.TYPE].stop();
    this.props.audioEnd();
  };

  changeBtnStatus = (data) => {
    const json = JSON.parse(data.playData);
    (!this.isSoundEffect() || json.type === 'header') && this.props.changeBtnStatus(json);
  };

  render = () => (
    <audio
      src={this.props.src}
      ref={this.audioRef}
      onEnded={this.stop}
    />
  );
}
NativeAudioBtn.propTypes = {
  src: PropTypes.string,
  playData: PropTypes.object,
  audioEnd: PropTypes.func,
  changeBtnStatus: PropTypes.func,
  // type: PropTypes.string,
};

export default NativeAudioBtn;
